import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
export class CardWithDataRenderer extends React.PureComponent {
  static moduleImporter(target) {
    import(
    /* webpackChunkName: "@atlaskit-internal_smartcard-datacardcontent" */
    './component').then(module => {
      CardWithDataRenderer.CardContent = module.CardWithDataContent;
      target.forceUpdate();
    });
  }

  componentDidMount() {
    if (CardWithDataRenderer.CardContent === null) {
      (this.props.importer || CardWithDataRenderer.moduleImporter)(this);
    }
  }

  render() {
    const {
      id,
      appearance,
      data,
      isSelected,
      onClick,
      onResolve,
      testId,
      showActions,
      inlinePreloaderStyle
    } = this.props;

    if (!data) {
      throw new Error('@atlaskit/smart-cards: you are trying to render a card with data, but does not provide any');
    }

    if (CardWithDataRenderer.CardContent) {
      return /*#__PURE__*/React.createElement(CardWithDataRenderer.CardContent, {
        id: id,
        inlinePreloaderStyle: inlinePreloaderStyle,
        appearance: appearance,
        data: data,
        isSelected: isSelected,
        onClick: onClick,
        onResolve: onResolve,
        testId: testId,
        showActions: showActions
      });
    }

    return /*#__PURE__*/React.createElement("div", {
      "data-card-with-data": true
    });
  }

}

_defineProperty(CardWithDataRenderer, "CardContent", null);